import * as yup from 'yup';

import { AddressFieldsFormFields } from 'src/constants/address';
import { REQUIRED_VALIDATION_MESSAGE } from 'src/constants/validationMessage';

import { ERROR_MESSAGE_REQUIRED_ZIP_CODE, zipCodeValidationSchema } from './zip';

export const addressFieldsValidationSchema = yup.object({
  [AddressFieldsFormFields.street]: yup.string().nullable().required(REQUIRED_VALIDATION_MESSAGE),
  [AddressFieldsFormFields.zipCode]: zipCodeValidationSchema.required(
    ERROR_MESSAGE_REQUIRED_ZIP_CODE,
  ),
  [AddressFieldsFormFields.city]: yup.string().nullable().required(REQUIRED_VALIDATION_MESSAGE),
  [AddressFieldsFormFields.county]: yup.string().nullable().required(REQUIRED_VALIDATION_MESSAGE),
  [AddressFieldsFormFields.state]: yup.string().nullable().required(REQUIRED_VALIDATION_MESSAGE),
});
